/*
PM 2021-07-29
KONCEPCJA KOMPONENTU
================

Komponent mapy

================

Kontener mapy to komponent MapContainer (zaimportowany z biblioteki react-leaflet)
Propsy komponentu MapContainer:
* center - wspolrzedne srodka mapy, tylko do inicjacji, brane z propsa obszar (od komponentu rodzica MapContainer)

Wybor warstwy (stylu) mapy to komponent LayersControl (zaimportowany z biblioteki react-leaflet)
Warstwy do wyboru to komponenty LayersControl.BaseLayer
Props checked mowi, ktora warstwa jest wyswietlana domyslnie
Warstwy sa renderowane przez komponenty TileLayer (zaimportowany z biblioteki react-leaflet)
Mozna je nakladac na siebie

Na mapie sa renderowane obiekty noclegowe jako pineski - komponenty Marker (zaimportowany z biblioteki react-leaflet)
Komponent Tooltip to dymek pojawiajacy sie po najechaniu na pineske (zaimportowany z biblioteki react-leaflet)
Style markerow brane z propsa - funkcji getIcon (od komponentu rodzica MapContainer)

================
importowane komponenty:

*/

import * as React from 'react';

import {
    MapContainer, TileLayer, Marker, Tooltip, LayersControl,
    ZoomControl, ScaleControl, Circle, Pane, Polygon, Polyline, useMap, Popup, useMapEvents
} from 'react-leaflet';

import 'leaflet/dist/leaflet.css';

import L, { TileErrorEvent, LayersControlEvent, LeafletMouseEvent } from 'leaflet';

import { connect } from 'react-redux';

import { AppState, IPageState, store, Actions } from '../../appredux';
import { tiles } from './mapData';
import { Info } from '../../api';

import Routing from "./Routing";
import Search from "./Search";
import './Routing.css';
import './Map.css';
import { Fab } from '@material-ui/core';
import { MapData } from './MapContainer';
import { MuiThemeProvider} from '@material-ui/core/styles';
import theme from 'themes';

import 'leaflet-geosearch/dist/geosearch.css';
import * as M from '@material-ui/core';
import { HaversineInM } from './Distance';
import CONFIG from 'cfg/config';

export const ThemeOrange = M.createTheme({
    palette: {
      primary: {
        main: "#e65100",
      },
      secondary: {
        main: "#3a87ad",
      },
    },
  });


//PM 2021-11-30
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface MapProps {
    page: IPageState,
    contact: Info,
    map: MapData,

    distance: number,
    address: string,
    getIcon: (color: number) => L.Icon | undefined, //pobieranie koloru pineski
    latObiekt: number,                                    //szer. geogr.
    lngObiekt: number,                                    //dl. geogr.
    latClient: number,                                    
    lngClient: number,                                    
    bounds: L.LatLngBoundsExpression,               //początkowe granice mapy
    tooltip: string,                                //opis przy pinesce
    tileErrors: string[],
    tileName: string,
    addTileError: (aName: string) => Promise<void>,
    setTileName: (aName: string) => Promise<void>,
    update: () => void
}

interface MapState {
    //isMapInit: boolean,
    mode: number,   // 0 - odległość, 1 - trasa
    //refresh: number

    //clickLat: number,
    //clickLng: number

}
const GEOCODE_URL = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&langCode=PL&location=";

class Map extends React.Component<MapProps, MapState>  {
    mapRef: any; //React.RefObject<L.Map>; useRef(null)


    constructor(props: MapProps) {
        super(props, {});
        this.mapRef = React.createRef() //as React.RefObject<L.Map>
        //this.mapRef = React.useRef(null) //as React.RefObject<L.Map>
        this.state = {
            //isMapInit: false,
            mode: 0,
            
            //refresh: 0
            //clickLat: 0,
            //clickLng: 0
        }

    //     setInterval(() => {
    //         let input1 = document.getElementsByClassName("glass")
    //   console.log(input1)
    //   if(input1.length >0 ){
    //     input1[0].setAttribute("value", "Rzeszów, ")
    //   }
    //     }, 300);
    }

    componentDidMount(): void {
        setTimeout(() => {
            if(this.props.map.klientAdres){
                let input = document.getElementsByClassName("glass")
                if (input.length > 0) {
                    input[0].setAttribute("value", this.props.map.klientAdres)
    
                }
            }
        }, 100);
       
    }

    // componentDidUpdate(prevProps: MapProps, prevState: MapState) {
    //     console.log(this.mapRef)
    //     if(this.props.map.obiektGPS !== prevProps.map.obiektGPS){
    //         //if(this.mapRef){
    //             this.setState({refresh: this.state.refresh + 1})
    //             //console.log(this.mapRef)
    //             //this.mapRef.current.setView(new L.LatLng(40.737, -73.923), 8);
    //         //}
    //     }
      
    //   }

    //PM 2021-11-04 zrezygnowano
    // mapPlaceholder = () => {
    //     const { classes } = this.props

    //     return (
    //         <div className={classes.frame} style={{ width: '100%', height: '100%' }}>
    //             <span className={classes.helper}></span>
    //             <img
    //                 className={classes.img}
    //                 style={{ maxWidth: '1000px', width: window.innerWidth > 600 ? '' : (window.innerWidth - 30) + 'px' }}
    //                 src="img/map-placeholder.jpg"
    //                 alt="Brak mapy"
    //             />
    //         </div>
    //     )
    // }

    //PM 2021-10-19
    baseLayerChange = async (event: LayersControlEvent) => {
        await this.props.setTileName(event.name)
    }

    //raz przy tworzeniu mapy
    //PM 2021-10-19
    whenCreated = (map: any) => {
        //console.log(map)
        map.target.on('baselayerchange', this.baseLayerChange);
        this.mapRef.current = map

        //this.setState({
        //    isMapInit: true
        //  });
    }

    //PM 2021-11-30
    tooltip = () => {
        //const wspolrzedne = this.props.contact.kontaktGps.split(' ');
        //const wspolrzedne = this.props.map.obiektGPS.split(' ');

        //if (wspolrzedne.length === 2)
            return (
                <React.Fragment>
                    {this.props.tooltip}
                    <br />
                    {/* {this.props.contact.kontaktGps} */}
                    {this.props.map.obiektGPS}
                </React.Fragment>
            )
        // else
        //     return (
        //         <React.Fragment>
        //             Wawel
        //             <br />
        //             {`${this.props.lat}N ${this.props.lng}E`}
        //         </React.Fragment>
        //     )
    }

    tooltipClient = () => {
        let distanceKM = (this.props.distance / 1000).toFixed(1) + " km"

        return (
            <React.Fragment>
                {this.props.address}
                <br />
                {distanceKM}
            </React.Fragment>
        )
    }

    changeMode = () => {
        this.setState({mode: this.state.mode ? 0 : 1 })
    }

    update = () => {
       this.props.update()
    }

    clickMap = async(event: LeafletMouseEvent) => {
        //console.log(event)
        //this.setState({clickLat: event.latlng.lat, clickLng: event.latlng.lng})

        // let d = new MapData({
        //     klientAdres: "test",
        //     klientLat: event.latlng.lat,
        //     klientLng: event.latlng.lng,
        // })
        // store.dispatch(Actions.pageState.setMap(d));
        
        try {
            const data = await (await fetch(GEOCODE_URL + `${event.latlng.lng},${event.latlng.lat}`)).json();
            //console.log(data.address);
            if (data && data.address && data.address.City) {
                let adres: string
                adres = data.address.Address ? data.address.Address + ", " + data.address.City : data.address.City
                adres = adres.split("ulica ").join("")

                let input = document.getElementsByClassName("glass")
                //if (input.length > 0) {
                    //let inputValue = townName(props.contact.kontaktAdres)
                    input[0].setAttribute("value", adres)

                let d = new MapData({
                    klientAdres: adres,
                    klientLat: event.latlng.lat,
                    klientLng: event.latlng.lng,
                    distance: Math.round( HaversineInM(this.props.map.obiektLat, this.props.map.obiektLng, event.latlng.lat, event.latlng.lng) )  
                })
                store.dispatch(Actions.pageState.setMap(d));
                
                //}
            }

        } catch (error) {
            console.error(error)
        }
          

    }

    //główna pętla
    //PM 2021-11-30
    //obsługa braku wspolrzednych do mapy
    render = () => {
        let selectedClient = this.props.latObiekt !== 0 && this.props.lngObiekt !== 0
                          && this.props.latClient !== 0 && this.props.lngClient !== 0   

                          //console.log(this.state)

        //let clickedMap = this.state.clickLat !== 0 && this.state.clickLng !== 0                  
                          
                                     
// maxHeight: window.innerWidth > 600 ? '' : window.innerWidth + 'px'
        return (
            <>
            <MapContainer 
                bounds={this.props.bounds}
                zoomSnap={0.1} zoomDelta={0.5}
                //style={{ height: (window.innerHeight - 200) + 'px', }}
                style={{ height: (window.innerHeight ) + 'px', }}
                zoomControl={false}
                //whenCreated={this.whenCreated}
                //whenCreated={(map: any) => {
                //    console.log("The underlying leaflet map instance:", map)
                //  }}
                // @ts-ignore
                whenReady={ (mapInstance: any) => { this.whenCreated(mapInstance) }} //this.mapRef.current =mapInstance
                // ref={m => {
                //     this.leafletMap = m;
                //   }}

                
            >
                {/* <SetViev refresh={this.state.refresh} lat={this.props.lat} lng={this.props.lng}/> */}

                <TileLayer 
                    attribution={tiles[0].attribution}
                    url={tiles[0].url}
                    eventHandlers={{
                        tileerror: async (event: TileErrorEvent) => {
                            if (!this.props.tileErrors.includes(tiles[0].name))
                                await this.props.addTileError(tiles[0].name)
                        }
                    }}
                />
                {/* <LayersControl >
                    {tiles.filter(tile => !this.props.tileErrors.includes(tile.name)).map((tile, index) => {
                        return (
                            <LayersControl.BaseLayer key={tile.name} checked={this.props.tileErrors.length && index === 0 ? true : tile.checked} name={tile.name}>
                                
                                <TileLayer
                                    attribution={tile.attribution}
                                    url={tile.url}
                                    eventHandlers={{
                                        tileerror: async (event: TileErrorEvent) => {
                                            if (!this.props.tileErrors.includes(tile.name))
                                                await this.props.addTileError(tile.name)
                                        }
                                    }}
                                />
                               
                            </LayersControl.BaseLayer>
                        )
                    })} */}
                    {/* <LayersControl.BaseLayer name="Voyager Znaczniki">
                        <LayerGroup>
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png"
                            />
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}.png"
                            />
                        </LayerGroup>
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Dark Znaczniki">
                        <LayerGroup>
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png"
                            />
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/light_only_labels/{z}/{x}/{y}.png"
                            />
                        </LayerGroup>
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Voyager bez znaczników">
                        <TileLayer
                            attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                            url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Dark bez znaczników">
                        <TileLayer
                            attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                            url="https://{s}.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer> */}
                {/* </LayersControl> */}

                <LocationFinder clickMap={this.clickMap}/>



                <ZoomControl position="topright" />
                <ScaleControl position="bottomleft" />

                {/* {selectedClient ? */}
                
                    <>
                        <Circle center={[this.props.latObiekt, this.props.lngObiekt]} pathOptions={{color: "#64CA80", fillColor: "transparent"}}  radius={Number(CONFIG.dowozOkreg1)}  />  {/*, fillColor: "#64CA80" fillColor={"green"} color="green" */}
                        <Circle center={[this.props.latObiekt, this.props.lngObiekt]} pathOptions={{color: "#E2D83C", fillColor: "transparent"}} radius={Number(CONFIG.dowozOkreg2)}  /> {/*, fillColor: "#E2D83C" fillColor={"yellow"} color="yellow" */}
                        <Circle center={[this.props.latObiekt, this.props.lngObiekt]} pathOptions={{color: "#FF8184", fillColor: "transparent"}} radius={Number(CONFIG.dowozOkreg3)}  className="opacity" /> {/*, fillColor: "#FF8184" fillColor={"red"} color="red" */}
                    </>
                {/* : null} */}
                
                {this.state.mode === 0 && selectedClient ?     
                <Polyline pathOptions={{ color: 'green' }}
                    positions={[
                        [this.props.latObiekt, this.props.lngObiekt],
                        [this.props.latClient, this.props.lngClient],
                    ]} />

                : null} 

                {// @ts-ignore
                    <Search map={this.mapRef} mapProp={this.props.map} contact={this.props.contact}/> }  
                    
                { // @ts-ignore
                this.state.mode === 1 && selectedClient ? <Routing map={this.mapRef}  latRestaurant={this.props.latObiekt} lngRestaurant={this.props.lngObiekt} latClient={this.props.latClient} lngClient={this.props.lngClient} />     
                 : null} 
            
                {/* <Marker
                    position={[this.props.latObiekt, this.props.lngObiekt]}
                    icon={this.props.getIcon(1)}
                >
                    <Tooltip>
                        {this.tooltip()}
                    </Tooltip>
                </Marker> */}
                    
                {selectedClient ?
                    <Marker
                        position={[this.props.latClient, this.props.lngClient]}
                        icon={this.props.getIcon(1)} //2
                    >
                        <Tooltip>
                            {this.tooltipClient()}
                        </Tooltip>
                    </Marker>
                    : null} 

                {/* {clickedMap ?
                    <Marker
                        position={[this.state.clickLat, this.state.clickLng]}
                        icon={this.props.getIcon(2)}
                    >
                        <Tooltip>
                            {this.tooltipClient()}
                        </Tooltip>
                    </Marker>
                    : null}  */}
                
                    {/* {this.props.tileErrors.includes(this.props.tileName) ?
                    null
                    :
                    (
                        <React.Fragment>
                            <ZoomControl position="topright" />
                            <ScaleControl position="bottomleft" />
                            <Marker
                                position={[this.props.lat, this.props.lng]}
                                icon={this.props.getIcon(1)}
                            >
                                <Tooltip>
                                    {this.tooltip()}
                                </Tooltip>
                            </Marker>
                        </React.Fragment>
                    )} */}

               
            </MapContainer>
             <MuiThemeProvider theme={ThemeOrange}>
             {/* {selectedClient ?
                 <Fab
                     className="mapFab"
                     style={{ fontSize: "14px" }}
                     color="secondary"
                     onClick={() => this.changeMode()}
                 >
                    {this.state.mode === 0 ? "trasa" : "linia"}
                 </Fab> : null} */}

             {selectedClient ?
                 <Fab
                     className="mapFabKoniec"
                     style={{ fontSize: "14px" }}
                     color="secondary"
                     //aria-label="dodaj"
                     onClick={() => this.update()}
                 >
                     {"reset"}
                 </Fab> : null}
                 </MuiThemeProvider>
                 </>
        );
    }
}

// const styles = (theme: Theme) => ({
//     frame: {
//         whiteSpace: 'nowrap' as 'nowrap', /* This is required unless you put the helper span closely near the img */
//         textAlign: 'center' as 'center',
//     },
//     helper: {
//         display: 'inline-block',
//         height: '100%',
//         verticalAlign: 'middle'
//     },
//     img: {
//         verticalAlign: 'middle',
//         maxHeight: '447px',
//         maxWidth: '1000px'
//     }
// });

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
    contact: state.pageState.contact,
    map:  state.pageState.map
});

export default connect(mapStateToProps)(Map);

// interface  setVievProps {
//     refresh: number,
//     lat: number,
//     lng: number,
// }

// function SetViev(props:setVievProps) {
//     console.log("qqqqqqqqqqqqqqqqqqqqqqqqqq")
//     const map = useMap() as L.Map
//     map.setView([props.lat, props.lng],)
//     return null
//   }

interface LocationProps {
    clickMap: (event: LeafletMouseEvent) => void
}

const LocationFinder = (props: LocationProps) => {
    const map = useMapEvents({
        click(e) {
            props.clickMap(e)
            //console.log(e.latlng);
        },
    });
    return null;
};